// redux/reducers/noteReducer.js
import { NOTE_ACTIONS } from "./noteActions";

const initialState = {
  notesByStage: {}, // { progressId: { process: {...}, information: {...} } }
  isLoading: false,
  error: null,
};

export const noteReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTE_ACTIONS.SAVE_NOTE_REQUEST:
    case NOTE_ACTIONS.DELETE_NOTE_REQUEST:
    case NOTE_ACTIONS.LOAD_NOTES_REQUEST:
    case NOTE_ACTIONS.UPDATE_NOTE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case NOTE_ACTIONS.SAVE_NOTE_SUCCESS: {
      const noteData = action.payload;
      console.log("Save note success payload:", noteData); // Debug log

      const progressId = noteData.progress_id;
      const noteType = noteData.note_type;

      if (!progressId || !noteType) {
        console.error(
          "Missing progressId or noteType in save note response:",
          noteData
        );
        return state;
      }

      const transformedNote = {
        id: noteData.id,
        text: noteData.note,
        author: noteData.author_id,
        timestamp: noteData.created_at,
        lastModified: noteData.updated_at,
        lang: noteData.lang,
        businessId: noteData.business_id,
        progressId: noteData.progress_id,
        noteType: noteData.note_type,
      };

      console.log("Transformed note for store:", transformedNote); // Debug log

      return {
        ...state,
        isLoading: false,
        error: null,
        notesByStage: {
          ...state.notesByStage,
          [progressId]: {
            ...state.notesByStage[progressId],
            [noteType]: transformedNote,
          },
        },
      };
    }

    case NOTE_ACTIONS.UPDATE_NOTE_SUCCESS: {
      const noteData = action.payload;
      console.log("Update note success payload:", noteData); // Debug log

      const progressId = noteData.progress_id;
      const noteType = noteData.note_type;

      if (!progressId || !noteType) {
        console.error(
          "Missing progressId or noteType in update note response:",
          noteData
        );
        return state;
      }

      const transformedNote = {
        id: noteData.id,
        text: noteData.note,
        author: noteData.author_id,
        timestamp: noteData.created_at,
        lastModified: noteData.updated_at,
        lang: noteData.lang,
        businessId: noteData.business_id,
        progressId: noteData.progress_id,
        noteType: noteData.note_type,
      };

      return {
        ...state,
        isLoading: false,
        error: null,
        notesByStage: {
          ...state.notesByStage,
          [progressId]: {
            ...state.notesByStage[progressId],
            [noteType]: transformedNote,
          },
        },
      };
    }

    case NOTE_ACTIONS.DELETE_NOTE_SUCCESS: {
      const { noteId, progressId, noteType } = action.payload;
      const stageNotes = { ...state.notesByStage[progressId] };
      delete stageNotes[noteType];

      return {
        ...state,
        isLoading: false,
        notesByStage: {
          ...state.notesByStage,
          [progressId]: Object.keys(stageNotes).length > 0 ? stageNotes : {},
        },
      };
    }

    case NOTE_ACTIONS.LOAD_NOTES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notesByStage: action.payload,
      };

    case NOTE_ACTIONS.SAVE_NOTE_FAILURE:
    case NOTE_ACTIONS.DELETE_NOTE_FAILURE:
    case NOTE_ACTIONS.LOAD_NOTES_FAILURE:
    case NOTE_ACTIONS.UPDATE_NOTE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
